var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    {
      staticClass: "app-footer padding-y-3xl",
      staticStyle: {
        "background-color": "var(--fa-navy)",
        color: "var(--fa-gravy)",
        "--link-color": "var(--white)",
        "--link-hover-color": "var(--fa-blue)",
      },
      attrs: { id: "footer" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "margin-bottom-2xl" }, [
          _c(
            "div",
            {
              staticClass: "margin-y-2xl",
              staticStyle: { color: "var(--white)" },
            },
            [
              _c(
                "h2",
                { staticClass: "h5" },
                [
                  _c(
                    "site-link",
                    {
                      staticClass: "display-inline-block margin-right-2xs",
                      attrs: { to: { name: "home" } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.$posthog.capture(
                            "main_footer_link_click",
                            { destination: "home" }
                          )
                        },
                      },
                    },
                    [
                      _c("owa-logo-flag"),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Font Awesome"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v("\n          Go Make Something Awesome\n        "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "laptop:size-sm",
                  staticStyle: {
                    "--paragraph-margin-bottom": "var(--spacing-2xs)",
                  },
                },
                [
                  _vm._v(
                    "\n          Font Awesome is the internet's icon library and toolkit used by millions of designers, developers, and content creators.\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "laptop:size-sm" },
                [
                  _vm._v("\n          Made with\n          "),
                  _c("font-awesome-icon", {
                    staticClass: "margin-x-4xs app-footer-heart-flutter",
                    attrs: { icon: _vm.$v7.solid.faHeart, title: "love" },
                  }),
                  _vm._v("\n          and\n          "),
                  _vm.selectedFaveIcon === "faBlockQuestion"
                    ? _c("owa-question-mark-block", {
                        attrs: { "block-size": "lg" },
                      })
                    : _c("font-awesome-icon", {
                        staticClass: "margin-x-4xs",
                        attrs: { icon: _vm.$v7.solid[_vm.selectedFaveIcon] },
                      }),
                  _vm._v("\n          in\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Bentonville, AR",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Bentonville")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Boston, MA",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Boston")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Chicago, IL",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Chicago")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Grand Rapids, MI",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Grand Rapids")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Joplin, MO",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Joplin")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Kansas City, MO",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Kansas City")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Seattle, WA",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Seattle")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Tampa, FL",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Tampa")]
                  ),
                  _vm._v(", and\n          "),
                  _c(
                    "a",
                    {
                      staticClass: "no-underline",
                      attrs: {
                        href: "https://www.google.com/maps/place/Vergennes, VT",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Vergennes")]
                  ),
                  _vm._v(".\n        "),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row roomy align-top" }, [
            _c(
              "div",
              {
                staticClass:
                  "column-6 tablet:column-3 margin-bottom-xl laptop:margin-bottom-0",
              },
              [
                _c("h3", { staticClass: "h5 text-uppercase size-sm" }, [
                  _vm._v("Awesomeverse"),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: { href: "https://webawesome.com/" },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "web_awesome",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Web Awesome\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: { href: "https://www.11ty.dev/" },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "11ty",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            11ty\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: { href: "https://podcastawesome.com/" },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "podcast_awesome",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Podcast Awesome\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline",
                    attrs: {
                      href: "https://blog.fontawesome.com",
                      target: "_blank",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "blog",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Blog Awesome\n          ")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "column-6 tablet:column-3 margin-bottom-xl laptop:margin-bottom-0",
              },
              [
                _c("h3", { staticClass: "h5 text-uppercase size-sm" }, [
                  _vm._v("Font Awesome"),
                ]),
                _vm._v(" "),
                _c(
                  "site-link",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: { to: { name: "latest.download" } },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "download",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Download\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "site-link",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: { to: { name: "changelog" } },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "changelog",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Changelog\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "site-link",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: { to: { name: "versions" } },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "versions",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            All Versions\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "site-link",
                  {
                    staticClass: "display-block no-underline",
                    attrs: { to: { name: "leaderboard" } },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "leaderboard",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Icon Requests\n          ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "column-6 tablet:column-3 margin-bottom-xl laptop:margin-bottom-0",
              },
              [
                _c("h3", { staticClass: "h5 text-uppercase size-sm" }, [
                  _vm._v("Community"),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: {
                      href: "https://github.com/FortAwesome/Font-Awesome",
                      target: "_blank",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "github_project",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            GitHub\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: {
                      href: "https://www.youtube.com/@font.awesome",
                      target: "_blank",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "youtube",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            YouTube\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: {
                      href: "https://www.threads.net/@font.awesome",
                      target: "_blank",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "threads",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Threads\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline",
                    attrs: { href: "https://cottonbureau.com/font-awesome" },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "merch",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Awesome Swag\n          ")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column-6 tablet:column-3" },
              [
                _c("h3", { staticClass: "h5 text-uppercase size-sm" }, [
                  _vm._v("Help"),
                ]),
                _vm._v(" "),
                _c(
                  "site-link",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: { to: { name: "support" } },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "support",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Support\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "site-link",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: {
                      to: {
                        name: "latest.docs",
                        params: { pathMatch: "/web/troubleshoot" },
                      },
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "docs_web_troubleshooting",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Troubleshooting\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: {
                      href: "mailto:hello@fontawesome.com?subject=Hello, Font Awesome!",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.supportLinkClicked("page_footer")
                      },
                    },
                  },
                  [_vm._v("\n            Contact Us\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "display-block no-underline margin-bottom-2xs",
                    attrs: {
                      href: "https://status.fortawesome.com/",
                      target: "_blank",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture("main_footer_link_click", {
                          destination: "status",
                        })
                      },
                    },
                  },
                  [_vm._v("\n            Status\n          ")]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row roomy align-top tablet:size-sm" }, [
          _c(
            "div",
            {
              staticClass:
                "margin-bottom-xl display-flex flex-column tablet:flex-row laptop:margin-bottom-0",
            },
            [
              _c(
                "site-link",
                {
                  staticClass:
                    "display-inline-block no-underline margin-bottom-sm tablet:margin-bottom-0 tablet:margin-right-md",
                  attrs: { to: { name: "license.pro" } },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture("main_footer_link_click", {
                        destination: "license",
                      })
                    },
                  },
                },
                [_vm._v("\n          License\n        ")]
              ),
              _vm._v(" "),
              _c(
                "site-link",
                {
                  staticClass:
                    "display-inline-block no-underline margin-bottom-sm tablet:margin-bottom-0 tablet:margin-right-md",
                  attrs: { to: { name: "tos" } },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture("main_footer_link_click", {
                        destination: "terms_of_service",
                      })
                    },
                  },
                },
                [_vm._v("\n          Terms of Service\n        ")]
              ),
              _vm._v(" "),
              _c(
                "site-link",
                {
                  staticClass:
                    "display-inline-block no-underline margin-bottom-sm tablet:margin-bottom-0 tablet:margin-right-md",
                  attrs: { to: { name: "privacy" } },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture("main_footer_link_click", {
                        destination: "privacy_policy",
                      })
                    },
                  },
                },
                [_vm._v("\n          Privacy Policy\n        ")]
              ),
              _vm._v(" "),
              _c(
                "site-link",
                {
                  staticClass:
                    "display-inline-block no-underline margin-bottom-sm tablet:margin-bottom-0 tablet:margin-right-md",
                  attrs: { to: { name: "refunds" } },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture("main_footer_link_click", {
                        destination: "refunds",
                      })
                    },
                  },
                },
                [_vm._v("\n          Refunds\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "link flat text-left margin-0 padding-0 display-inline-block no-underline",
                  staticStyle: { "--button-border-radius": "0" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.manageCookiePreferences.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n          Cookie Preferences\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "column-12 laptop:column laptop:text-right" },
      [
        _c(
          "p",
          {
            staticStyle: { color: "var(--fa-gravy)", "white-space": "nowrap" },
          },
          [_vm._v("© Fonticons, Inc.")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }